/**
 * Project : workspace
 * File    : EcommerceHomeNavGraph.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.commerce.graph

import androidx.navigation.NavGraph
import androidx.navigation.compose.composable
import androidx.navigation.createGraph
import navigation.base.FriendlyWindow
import navigation.commerce.route.home.CommerceHomeNavRoute
import presentation.screens.common.account.AccountScreen
import presentation.screens.customer.order.list.OrderListScreen
import presentation.screens.customer.product.ProductDetailScreen
import presentation.screens.customer.store.StoreDetailScreen
import presentation.screens.customer.store.cart.ShoppingCart
import presentation.screens.customer.store.category.details.StoreCategoryDetailScreen
import presentation.screens.customer.store.payment.PaymentDetailScreen

/**
 * Represents the ecommerce home nav graph class.
 */

class EcommerceHomeNavGraph {
    fun navGraph(): NavGraph {
        val graph =
            FriendlyWindow.Companion.navigationController?.createGraph(startDestination = CommerceHomeNavRoute.HOME) {
                composable(route = CommerceHomeNavRoute.HOME) {
                    StoreDetailScreen().Content()
                }
                composable(route = CommerceHomeNavRoute.STORES) {
                    StoreDetailScreen().Content()
                }
                composable(route = CommerceHomeNavRoute.PRODUCT) {
                    ProductDetailScreen().Content()
                }
                composable(route = CommerceHomeNavRoute.CATEGORY) {
                    StoreCategoryDetailScreen().Content()
                }

                composable(route = CommerceHomeNavRoute.ORDER) {
                    OrderListScreen().Content()
                }
                composable(route = CommerceHomeNavRoute.SHOPPING_CART) {
                    ShoppingCart().Content()
                }
                composable(route = CommerceHomeNavRoute.ORDER_LIST) {
                    OrderListScreen().Content()
                }
                composable(route = CommerceHomeNavRoute.ORDER_PAYMENT){
                    PaymentDetailScreen().Content()
                }
                composable(route = CommerceHomeNavRoute.ACCOUNT) {
                    AccountScreen().Content()
                }
            }
        return graph!!
    }
}